import React from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Quiz from "./components/Quiz";
import QuizFeedback from "./components/QuizFeedback";
import SplashPage from "./components/SplashPage";
import NotFoundPage from "./components/NotFoundPage";
import { QUIZ_QUESTIONS } from "./constants/quizQuestionData";
import { QuizResponse } from "./types/QuizSubmission";
import LLMResults from "./components/LLMResults";

const SplashRoute: React.FC = () => {
  const navigate = useNavigate();

  const handleStartQuiz = () => {
    navigate('/quiz');
  };

  return <SplashPage onStart={handleStartQuiz} />;
};

const QuizRoute: React.FC = () => {
  const navigate = useNavigate();

  const handleQuizComplete = (quizResponses: QuizResponse[]) => {
    navigate('/feedback', { state: { responses: quizResponses } });
  };

  return <Quiz onComplete={handleQuizComplete} />;
};

const FeedbackRoute: React.FC = () => {
  const location = useLocation();

  const responses: QuizResponse[] = location.state?.responses || [];

  return <QuizFeedback questions={QUIZ_QUESTIONS} responses={responses} />;
};

const App: React.FC = () => (
  <Router basename="/projects/monty_hall_quiz">
    <div style={{ textAlign: 'center' }}>
      <Routes>
        <Route path="/" element={<SplashRoute />} />
	      <Route path="" element={<SplashRoute />} />
        <Route path="/quiz" element={<QuizRoute />} />
        <Route path="/feedback" element={<FeedbackRoute />} />
        <Route path="/llm-results" element={<LLMResults />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  </Router>
);

export default App;
